<template>
  <el-dialog
    class="rc-dialog"
    title="选择审核人"
    :visible.sync="dialogVisible"
    width="50%"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
  >
    <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
    <el-tree
      class="filter-tree"
      :data="auditorData"
      :props="defaultProps"
      default-expand-all
      :filter-node-method="filterNode"
      show-checkbox
      check-strictly
      check-on-click-node
      :expand-on-click-node="false"
      icon-class="-"
      node-key="id"
      @check-change="auditorCheckChange"
      ref="tree"
    >
    </el-tree>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="selectAuditor" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import Bus from "./bus";
import { videoAuditorList } from "@/api/videoAudit";
export default {
  data() {
    return {
      dialogVisible: false,
      filterText: "",
      auditorData: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      selectedAuditor: null
    };
  },
  watch: {
    filterText(val) {
      this.$refs["tree"].filter(val);
    }
  },
  created() {
    Bus.$on("selectAuditor", deptId => {
      this.dialogVisible = true;
      // 获取审核员数据
      videoAuditorList(deptId).then(res => {
        if (!res || res.code != 0) return;
        this.auditorData = res.data;
      });
    });
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    auditorCheckChange(data, checked) {
      if (checked) {
        this.selectedAuditor = data;
        this.$refs["tree"].setCheckedKeys([data.id]);
      } else {
        this.selectedAuditor = null;
      }
    },
    selectAuditor() {
      if (!this.selectedAuditor) {
        this.$message({
          message: "请选择审核员",
          type: "warning"
        });
      } else {
        Bus.$emit("didSelectAuditor", this.selectedAuditor);
        this.dialogVisible = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    overflow: hidden;
    padding-bottom: 40px;
    .filter-tree {
      margin-top: 20px;
      max-height: 200px;
      border: 1px solid #d7dbe0;
      border-radius: 2px;
      overflow-y: auto;
    }
  }
}
</style>
